"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-CheckmarkSmall" },
      _react2.default.createElement("path", { d: "M3.788 9A1 1 0 0 1 3 8.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6A1 1 0 0 1 3.788 9z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M4.5 11a1 1 0 0 1-.788-.385l-3-4A.991.991 0 0 1 .5 6a1 1 0 0 1 1.788-.616L4.5 8.376l5.212-6.991a1 1 0 1 1 1.576 1.231l-6 8A1 1 0 0 1 4.5 11z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'CheckmarkSmall';
exports.default = WrappedIcon;

